import * as api from "../../api/loginForm";
import { log2 } from "../../utils/log2";
import Vue from "vue";
import { toObject, toArray } from "../../utils/languageContent";
import { sendSocketMessage } from "../../utils/socketStream";
import { removePersistenceData } from "../../utils/persistenceStorage";

const log = log2("customLoginForm.vuex");
const customLoginForm = {
    namespaced: true,
    state: {
        inputs: [],
    },
    getters: {
        isCustomLoginFormEnabled: (state, _, rootState) => {
            log("root state is ", rootState);
            const enabledFlag = rootState.setting.settings.customLoginFormEnabled;
            const isValid = !!state.inputs.filter((x) => x.visible).length;
            return enabledFlag && isValid;
        },
    },
    mutations: {
        SET_ALL_INPUTS: (state, inputs) => {
            log.debug("SET_ALL_INPUTS", inputs);
            state.inputs = inputs.map((x) => toObject(x, "localizedLabel"));
        },
        UPDATE_INPUT: (state, input) => {
            log.debug("UPDATE_INPUT", input);
            const findIndex = state.inputs.findIndex((x) => x._id === input._id);
            if (findIndex !== -1) {
                Vue.set(state.inputs, findIndex, toObject(input, "localizedLabel"));
            }
        },
        CREATE_INPUT: (state, input) => {
            log.debug("CREATE_INPUT", input);
            state.inputs = _.orderBy([...state.inputs, toObject(input, "localizedLabel")], ["order"], ["asc"]);
        },
        DELETE_INPUT: (state, id) => {
            log.debug("DELETE_INPUT", id);
            state.inputs = state.inputs.filter((x) => x._id !== id);
        },
    },
    actions: {
        getCustomLoginFormInputs({ commit }) {
            return api.getAllLoginFormInputs().then((response) => {
                const inputs = response.data;
                commit("SET_ALL_INPUTS", inputs || []);
            });
        },
        updateInput({ commit, rootState }, input) {
            input = toArray(input, "localizedLabel");
            log("updateInput called", input);
            removePersistenceData("chatListCols");
            return api.updateLoginFormInput(input).then((response) => {
                commit("UPDATE_INPUT", response.data);
                sendSocketMessage("user custom-login-form-updated", {
                    siteId: rootState.site.site._id,
                });
                return Promise.resolve(response.data);
            });
        },
        multiUpdateInput({ commit, rootState }, inputs) {
            inputs = inputs.map((input) => toArray(input, "localizedLabel"));
            log("multiUpdateInput called", inputs);
            removePersistenceData("chatListCols");
            return api.multiUpdateFormInputs(inputs).then((response) => {
                response.data.forEach((input) => {
                    commit("UPDATE_INPUT", input);
                });
                sendSocketMessage("user custom-login-form-updated", {
                    siteId: rootState.site.site._id,
                });
                return Promise.resolve(response.data);
            });
        },
        createInput({ commit, rootState }, input) {
            input = toArray(input, "localizedLabel");
            log("updateInput called", input);
            removePersistenceData("chatListCols");
            return api.createLoginFormInput(input).then((response) => {
                commit("CREATE_INPUT", response.data);
                sendSocketMessage("user custom-login-form-updated", {
                    siteId: rootState.site.site._id,
                });
                return Promise.resolve(response.data);
            });
        },

        deleteInput({ commit, rootState }, id) {
            log("deleteInput called", id);
            removePersistenceData("chatListCols");
            return api.deleteLoginFormInputById(id).then((response) => {
                commit("DELETE_INPUT", id);
                sendSocketMessage("user custom-login-form-updated", {
                    siteId: rootState.site.site._id,
                });
            });
        },
        multiSetInputs({ commit, rootState }, inputs) {
            log("multiSetInputs called", inputs);
            removePersistenceData("chatListCols");
            commit("SET_ALL_INPUTS", inputs);
        },
    },
};

export default customLoginForm;
